import { render, staticRenderFns } from "./TickNIChart.vue?vue&type=template&id=b99f548e&"
import script from "./TickNIChart.vue?vue&type=script&lang=js&"
export * from "./TickNIChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports